module.exports = __webpack_public_path__ + "static/media/cooper-error-404.adfd124b.png";